import {
    Configuration,
    DomainSimulationManagementApi,
    LiveControlsApi,
} from '@control-center/control-center-client-public-domain-simulation-ts';
import { fetchAuthSession } from 'aws-amplify/auth';
import axios from 'axios';
import { CORRELATION_ID_LABEL } from 'graphql/constants';
import { v4 as uuid } from 'uuid';

const domain = import.meta.env.VITE_SIMULATION_ROUTE;

const axiosInstance = axios.create({ timeout: 30_000 });

axiosInstance.interceptors.request.use(async config => {
    const { tokens } = await fetchAuthSession();
    const accessToken = tokens?.accessToken?.toString();

    if (accessToken) {
        config.headers.set('Authorization', `Bearer ${accessToken}`);
    }
    config.headers.set('Accept', 'application/json');
    config.headers.set(CORRELATION_ID_LABEL, uuid());

    // Remove the axios default Content-Type on requests without a body
    // to avoid triggering CORS preflights the backend doesn't handle.
    if (!config.data) {
        config.headers.delete('Content-Type');
    }

    return config;
});

const configuration = new Configuration({ basePath: `${domain}/simulator-adapter-service` });

export const managementApi = new DomainSimulationManagementApi(configuration, undefined, axiosInstance);
export const liveControlsApi = new LiveControlsApi(configuration, undefined, axiosInstance);
